export default async function operator({ next }) {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    
    if (!user) {
      return next({ name: "Login" });
    }

    // Verificar que el usuario sea operador (role === '3')
    if (user.role !== '3') {
      // Si no es operador, redirigir al dashboard principal
      return next({ name: "Dashboard" });
    }

    next();
  } catch (error) {
    console.error("Error en middleware operator:", error);
    return next({ name: "Login" });
  }
}
